module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "form-date-input.717eac66.svg";